// TokenRuler figures out the pixel coordinates for tokens that
// the user has typed into the text input. It does this by creating
// an exact copy of the input's text with tokens wrapped in spans,
// then it measures the spans.
export default class TokenRuler {
  constructor($container) {
    this.$container = $container;
    this.spans = [];
  }

  update(tokens, selectedToken) {
    this.spans = [];
    this.$container.empty();
    tokens.forEach(token => {
      const $s = $('<span>')
        .text(token.text)
        .addClass(token.kind);
      if (token === selectedToken) {
        $s.addClass('editing');
      }
      this.$container.append($s);
      this.spans.push($s);
    });
  }

  tokenCount() {
    return this.spans.length;
  }

  dimensions(i, scroll) {
    const padding = this.padding(i);
    const pos = this.spans[i].position();
    return {
      top: pos.top - padding.vertical,
      left: pos.left - padding.horizontal + (scroll || 0),
      width: this.spans[i].width() + padding.horizontal * 2,
      height: this.spans[i].height() + padding.vertical * 2,
    };
  }

  // Calculates horizontal padding based on gaps between spans. Clamps it
  // so that 0 < hpadding < 5. We do this so we don't have to trust
  // browers to render the word-spacing CSS identically. Vertical padding
  // is set to a fixed value.
  padding(i) {
    if (this.spans[i].is('.whitespace')) {
      return { horizontal: 0, vertical: 0 };
    }

    const spans = this.spans;
    let gap;

    if (spans[i + 2]) {
      gap = this.gap(spans[i], spans[i + 2]);
    } else if (spans[i - 2]) {
      gap = this.gap(spans[i - 2], spans[i]);
    } else {
      gap = 15;
    }

    return { horizontal: Math.min(Math.max(0, gap / 3), 5), vertical: 3 };
  }

  gap(l, r) {
    const $l = $(l);
    return $(r).position().left - $l.position().left - $l.width();
  }

  isHighlightable(i) {
    return !this.spans[i].is('.whitespace');
  }
}
